var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.show ? '' : 'hidden'},[_c('v-progress-linear',{staticStyle:{"margin":"0 auto"},attrs:{"value":_vm.value,"height":"5"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }